import form from "./form/zhCN";

export default {
    form: form
}
